import React from 'react'
import CardSection from '../budha-fellowship-program/cardSection'

const AboutUsAdmin = () => {
  return (
   <>
     <CardSection section='07(The Board of Trustees and the Team)' sectionTitle='The Board ' role='theBoard' />
     <CardSection section='07(The Board of Trustees and the Team)' sectionTitle='The Team' role='theTeam' />
     <CardSection section='07(The Board of Trustees and the Team)' sectionTitle='US Board' role='Usboard' />
   </>
  )
}

export default AboutUsAdmin
